var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.examplefile.name))]),_vm._v(" "),_c('v-card-text',[_c(_vm.examplefile.name_component,{tag:"component",attrs:{"input":_vm.examplefile,"constants":_vm.constants,"valuelists":_vm.valuelists}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }